import { useQuery, useQueryClient } from '@zg-rentals/react-query5';
import type { PartialDeep } from 'type-fest';
import type { HpResolvedStateDto } from '@zg-rentals/ts-hotpads-api-client';

type ResolvedSearch = PartialDeep<HpResolvedStateDto>;

export const currentResolvedSearchKey = ['search', 'currentResolvedSearch'] as const;

export const useCurrentResolvedSearch = () => {
  return useQuery<ResolvedSearch | null>({
    queryKey: currentResolvedSearchKey,
    queryFn: () => {
      throw new Error('Resolved search state should be set via useSetCurrentResolvedSearch');
    },
    enabled: false,
    staleTime: Infinity,
  });
};

export const useSetCurrentResolvedSearch = () => {
  const queryClient = useQueryClient();

  return (resolved: ResolvedSearch | null) => {
    queryClient.setQueryData(currentResolvedSearchKey, resolved ?? null);
  };
};
